import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
      >
        <path
          fill="#D2E4FF"
          fillOpacity=".7"
          fillRule="nonzero"
          d="M4.291 1.659L7.922 5.29 12.544.669l-.66-.66-3.962 3.96L4.952 1h2.31v-.99H3.301v3.96h.99V1.66zm11.356 7.394A11.163 11.163 0 0 0 7.922 5.95c-2.97 0-5.743 1.188-7.724 3.103A.6.6 0 0 0 0 9.515a.6.6 0 0 0 .198.462l1.65 1.65a.6.6 0 0 0 .463.199.6.6 0 0 0 .462-.198c.528-.462 1.122-.924 1.782-1.255.198-.132.396-.33.396-.594V7.733c.925-.33 1.981-.462 3.037-.462 1.057 0 2.113.198 3.037.462v2.046c0 .264.132.462.396.594.66.33 1.255.727 1.783 1.255a.6.6 0 0 0 .462.198.6.6 0 0 0 .462-.198l1.65-1.65a.6.6 0 0 0 .199-.463c0-.198-.198-.33-.33-.462z"
        />
      </svg>
    )
  }
}

export default IcRightArrow
